import MyAccount from './MyAccount.page';

export default MyAccount;